import { Report } from 'types'

import { orgScopedApiClient } from '../../orgScopedClient'
import { CerebroPaginatedResponse } from '../types'

export const getDownloads = (
    params: Record<string, unknown>
): Promise<CerebroPaginatedResponse<Report>> =>
    orgScopedApiClient.get('/api/downloads/', {
        params,
    })
